import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { ResultTable } from './ResultTable';
import styles from '../../styles/LessonView.module.css';
export function ExampleRunner({ description, sql, onRun }) {
    const [result, setResult] = useState(null);
    const [running, setRunning] = useState(false);
    const handleRun = async () => {
        setRunning(true);
        try {
            setResult(await onRun());
        }
        finally {
            setRunning(false);
        }
    };
    return (_jsxs("div", { className: styles.exampleSection, children: [_jsx("div", { className: styles.sectionLabel, children: "\uD83D\uDCDD \u041F\u0440\u0438\u043C\u0435\u0440" }), _jsx("div", { className: styles.exampleDescription, children: description }), _jsx("div", { className: styles.sqlBlock, children: sql }), _jsx("button", { className: styles.runBtn, onClick: handleRun, disabled: running, children: running ? '⏳ Выполняю...' : '▶ Запустить' }), result && (_jsxs("div", { className: styles.resultSection, children: [_jsx("div", { className: styles.resultLabel, children: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442:" }), result.success && result.result ? (_jsx(ResultTable, { result: result.result })) : (_jsx("div", { className: styles.errorMessage, children: result.error }))] }))] }));
}
